import connectToForm from '@frontend/jetlend-core/src/ducks/connectToForm';
import { MaskInputField } from '@frontend/jetlend-web-ui/src/ui/inputs/MaskInput/MaskInput';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import InlineTextInput from '@frontend/jetlend-web-ui/src/ui/inputs/InlineTextInput/InlineTextInput';
import { trimEmailValue } from '@frontend/jetlend-core/src/utils/trimEmailValue';
import { FormAlert } from '@frontend/jetlend-web-ui/src/ui/forms/FormAlert/FormAlert';
import Link from 'next/link';
import useFormHandler from '@frontend/jetlend-core/src/hooks/useFormHandler';
import { useEffect } from 'react';
import styles from './StageEmailConfirm.module.scss';
import { limitPrescoringRegisterFormHandler } from '@app/ducks/borrowers/borrowers';
import { BorrowerLimitPrescoringContacts } from '@app/models/borrowers/limitPrescoring';
import { getCorrectFirstPhoneNumberFigure } from '@app/utils/getCorrectFirstPhoneNumberFigure';
import ScoringProcess from '../ScoringProcess/ScoringProcess';

export interface Props {

}

/**
 * Компонент контента модального окна прескоринга на стадии Email Confirm
 * (подтверждение контактов)
 */
export default connectToForm<Props, BorrowerLimitPrescoringContacts>(function StageEmailConfirm({
    handleSubmit,
    formSubmitting,
    invalid,
    dirty,
}) {

    const {
        initialize,
        reset,
    } = useFormHandler(limitPrescoringRegisterFormHandler);

    useEffect(() => {
        reset();
        initialize({
            email: '',
            phone: '',
        });
    }, [ reset, initialize ]);

    return (
        <div className={styles['content']}>
            <div className={styles['contacts']}>
                <MaskInputField
                    mask="+7 000 000-00-00"
                    prepareChar={getCorrectFirstPhoneNumberFigure}
                    label="Номер телефона...."
                    name="phone"
                    inputType="tel"
                    autoComplete="tel"
                    disabled={formSubmitting}
                    className={styles['input']}
                    noMarginBottom
                />
                <InlineTextInput
                    name="email"
                    label="E-mail"
                    inputType="email"
                    autoComplete="email"
                    normalize={trimEmailValue}
                    autoFocus
                    disabled={formSubmitting}
                    noMarginBottom
                    className={styles['input']}
                />
                <div className={styles['legal']}>
                    <div>
                        Ввод номера телефона подтверждает ваше согласие с{' '}
                        <Link href="/doc-view/rules" target="_blank">правилами платформы</Link>{' '}
                        и&nbsp;
                        <Link href="/doc-view/privacy" target="_blank">
                            политикой&nbsp;обработки персональных данных
                        </Link>
                    </div>
                </div>
                <Button
                    text="Получить код"
                    buttonType="submit"
                    size="big"
                    onClick={handleSubmit}
                    className={styles['button']}
                    loading={formSubmitting}
                    disabled={formSubmitting || invalid || !dirty}
                    containerClassName={styles['button-container']}
                    type="primary"
                />
            </div>

            <FormAlert
                alert="Подтвердите телефон и почту для отображения лимита"
                className={styles['alert']}
            />
            <ScoringProcess />
        </div>
    );
}, limitPrescoringRegisterFormHandler);